<template>
    <div class="register">
        <div class="register__image"></div>         
        <div class="register__container">
            <a @click="goback()" class="register__goback"><i class="material-icons">close</i></a>
            <div class="step">
                <div class="step-header">
                    <img src="@\assets\logo.svg" alt="Logo Forge">
                    <div>
                        <h1 class="bold">Ya casi estamos</h1>
                        <h1>Chequea tu correo</h1>
                    </div>
                </div>
                
                <div class="step__content">
                    <img src="@\assets\preInscription_ilustration.png" alt="email">
                    <h3 class="bold">¿Cómo seguimos?</h3>
                    <h4>Enviamos a tu correo la contraseña con la que deberás ingresar a la plataforma haciendo <a href="/login">click&nbsp;aquí</a>. Podrás cambiarla en el siguiente paso.</h4>
                    <a @click="activeModalEmail = true">¿No has recibido el correo?</a>
                </div>
            </div>
        </div>

        <Modal v-if="activeModalEmail" :isOpen="activeModalEmail" @close="activeModalEmail = false">
            <div class="modal__email">
                <i class="material-icons-outlined">error_outline</i>
                <h3>¿No has recibido el correo?</h3>
                <span>No hay problema, lo reenviaremos a:</span>

                <div class="email">
                    <i class="material-icons">mail_outline</i> {{dataModel.email}}
                </div>

                <div class="buttons">
                    <button class="back" @click="activeModalEmail = false">Cancelar</button>
                    <button class="next" @click="sendMail" v-if="!sendFormMail">Continuar <i class="material-icons">east</i></button>
                    <button class="next" disabled v-else>Enviando <i class="material-icons">east</i></button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';
import Modal from '@/components/Modal.vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
    components:{
        Modal,
        Datepicker
    },
    setup() {
        const v$ = useVuelidate();
        const store = useStore();
        const stepSelected =  ref(1);
        const step_invalid = ref(false);
        const submitted = ref(false);
        const sendForm = ref(false);
        const sendFormMail = ref(false);
        const activeModalEmail = ref(false);
        const router = useRouter();
        const paises = ref([]);

        const dataModel = ref({
            nombre: '',
            apellido: '',
            email: '',
            fechaNacimiento: '',
            paisId: ''
        });
        const format = (date) => {
            const day = date.getDate()
            const month = date.getMonth() + 1
            const year = date.getFullYear()

            return `${day}/${month}/${year}`
        }

        onMounted(async () => {
            const res = await store.dispatch('inscription_getPaises');
            paises.value = res.data.paises;
        });


        async function postData(){
            submitted.value = true;
            sendForm.value = true;
            if (!v$.value.dataModel.$invalid) {
                try {
                    await store.dispatch('inscription_postPreInscription', dataModel.value);
                    stepSelected.value = 2;
                } catch (error) {
                    store.dispatch('notifications_create', { text: 'Ocurrió un error, intenta nuevamente' })
                } finally{
                    submitted.value = false;
                    sendForm.value = false;
                    step_invalid.value = false;
                }
            } else {
                step_invalid.value = true;
                sendForm.value = false;
            }
        }

        function goback () {
            router.push('/login');
        }

        async function sendMail() {
            sendFormMail.value = true;
            try {
                await store.dispatch('security_beginPasswordRecovery', {email : dataModel.value.email});
            } catch (error) {
                store.dispatch('notifications_create', { text: 'Ocurrió un error, intenta nuevamente' })
            } finally{
                activeModalEmail.value = false;
                sendFormMail.value = false;
            }
        }

        return  {
            v$,
            dataModel,
            stepSelected,
            postData,
            step_invalid,
            submitted,
            activeModalEmail,
            sendMail,
            paises,
            sendForm,
            sendFormMail,
            goback,
            format
        }
    },
    validations(){
        return{
            dataModel: {
                nombre : { required },
                apellido : { required },
                fechaNacimiento : { required,
                minValue(val) {
                    return new Date(val) > new Date('01-01-1900')
                } },
                email : { required,
                            email: helpers.withMessage('El formato del mail es inválido', email) },
                paisId : { required }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.create-account {
      width: 100%;
      margin: 12px 0 16px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      a{
        color: $green;
      } 
    }

.register {
    display: grid;
    grid-template-columns: 1fr 1fr;
    height: 100vh;
    
    @media only screen and (max-width: 992px) {
        grid-template-columns: 1fr;

        &__image {
            display: none;
        }
    }

    &__goback {
        position: absolute;
        top: 20px;
        right: 20px;
    }

    &__image {
        background: url('~@/assets/preinscription_portrait.jpg') no-repeat center center;
        background-size: cover;
    }

    &__container {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #fff;
        justify-content: center;
        padding: 50px 20px 20px 20px;
        position: relative;

        .header-steps{
            display: flex;
            flex-direction: column;
            gap: 24px;
            
            .step{
                @include icon-and-text-container;
            
                i:first-child{
                    width: 28px;
                    height: 28px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 100%;
                    background: #FFB23F;
                    color: #fff;
                }
            }
        }

        .step{
            max-width: 400px;
            
            &-header{
                @include flex-column;
                gap: 32px;

                strong {
                    color: $green;
                }
                
                h1 {
                    text-align: center;
                    font-size: 24px;

                    &.bold {
                        font-weight: 800;
                    }
                }
                
                h3{
                    font-size: 20px;
                    font-weight: 600;
                }

                img {
                    width: 72px;
                    margin: auto;
                }
            }
            
            &__form{
                padding: 22px 0 36px 0;
                display: flex;
                flex-direction: column;
                gap: 16px;
            
                h5{
                    padding-top: 4px;
                    font-size: 13px;
                    font-weight: 700;
                }
                
                &__onClose{
                    display: flex;
                    gap: 24px;
                    >div{
                        display: flex;
                        gap: 8px;
                    }
                }
                .info-label-date{
                    @include icon-and-text-container;
                    font-weight: 600;
                    font-size: 10px;
                    .material-icons{
                        font-size: 19px;
                    }
                }
            }

            &__content {
                display: flex;
                flex-direction: column;
                gap: 24px;
                text-align: center;

                a {
                    color: $green;
                    font-weight: bold;
                }

                img {
                    margin: 24px 0;
                }

            }

            &__buttons {
                display: flex;
                justify-content: space-around;
                margin-bottom: 24px;

                .back{
                    width: 100%;
                    padding: 13px 0;
                    @include icon-and-text-container;
                    justify-content: center;
                    background: #fff;
                    border: 1px solid;
                    border-radius: 44px;
                    color: $green;
                    font-weight: 600;
                    font-size: 16px;
                    .material-icons{
                        font-size: 18px;
                    }
                }

                .next{
                    width: 100%;
                    padding: 13px 0;
                    @include icon-and-text-container;
                    justify-content: center;
                    background: $green;
                    border-radius: 44px;
                    color: #fff;
                    font-weight: 600;
                    font-size: 16px;
                    .material-icons{
                        font-size: 18px;
                    }
                }
            }

            &__terms {
                font-size: 12px;
                text-align: center; 

                a {
                    color: $green;
                    font-weight: bold;
                }
                // line-height: 16px;
            }
        }
    }

}

.modal__email{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    i {
        color: $green;
    }

    .email {
        display: flex;
        align-content: center;
        gap: 12px;
    }

    .buttons {
        display: flex;
        justify-content: space-around;
        margin-bottom: 24px;
        width: 80%;
        gap: 24px;

        .back{
            width: 100%;
            padding: 13px 0;
            @include icon-and-text-container;
            justify-content: center;
            background: #fff;
            border: 1px solid;
            border-radius: 44px;
            color: $green;
            font-weight: 600;
            font-size: 16px;
        }

        .next{
            width: 100%;
            padding: 13px 0;
            @include icon-and-text-container;
            justify-content: center;
            background: $green;
            border-radius: 44px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            .material-icons{
                color: white;
                font-size: 18px;
            }
        }
    }
}

.input {
    height: 50px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F6F6F6;
    border-radius: 50px;
    border: none;

    label{
        padding-right: 6px;
        background: #F6F6F6;
        font-size: 13px;
        font-weight: 400;
    }
    
    input, select{
        background: #F6F6F6;
        border: none;
        flex-grow: 1;
        font-size: 14px;
    }
}

.invalid-box-info{  
    margin: 16px 0;
    padding: 14px 20px;
    display: flex;
    align-items: stretch;
    background: rgba(255, 189, 176, 0.5);;
    >div{
        display: flex;
        flex-direction: column;
        &:first-child{
            width: fit-content;
            .material-icons{
                padding-right: 6px;
                color: $red;
            }
        }
        &:last-child{
            flex-grow: 1;
            gap: 12px;
            font-size: 14px;
        }
    }
    &__title{
        padding-top: 2px;
        font-weight: 700;
        color: $red;
    }
    &__info{
        font-weight: 500;
    } 
}

@mixin modals{
    padding: 36px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: #FFFFFF;
    border-radius: 10px;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25);
    h3{
        font-weight: 700;
        font-size: 20px;
    }
    .modal__buttons{
        justify-content: flex-end;
        gap: 40px;
        font-weight: 600;
        font-size: 16px;
        .cancel{
            border: none;
        }
        .confirm{
            width: fit-content;
            height: 45px;
            padding: 0 42px;
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
            border-radius: 44px;

            .green {
                background-color: #4caf50;
            }
        }
    }
}

.invalid-field{
    color: $login-error-color;
    *{
        color: $login-error-color;
    }
    border: 1px solid $login-error-color;
}

.invalid-message {
    margin-top: 4px;
    @include icon-and-text-container;
    gap: 4px;
    font-size: 12px;
    font-weight: 500;
    color: $login-error-color;
    .material-icons{
        font-size: 16px;
    }
}
</style>
